import { sortBy } from 'lodash-es'
import type {
  Rest,
  Shift
} from 'snap-redux/infra/http/routesConfig/scopes/planning/types'

export const sortByDate = <T extends Rest | Shift>(arr: T[]) => {
  return sortBy(arr, item => item.starts_at)
}
